import {navigateToPage, getHomepageUrl} from '../../../../../shared/scripts/ui_utils/ClientUtils'
import {AjaxDataTypes} from '../../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../../shared/entity_datas/EntityDatas'
import {StorageWrapper} from '../../../../../shared/scripts/StorageWrapper'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {CA} from '../../../../../shared/scripts/analytics/Analytics'
import {UITopNotificationType} from '../../../../../shared/scripts/notifications/UINotificationController'
import {UIMGameMode} from '../../../UIMGameModeController'
import {UIMNotificationView} from '../../../notifications/UIMNotificationView'

export class UIMMenuGameOrientationController {
    constructor() {
        const portraitToggle = document.getElementById('m-menu-mode-portrait')
        const landscapeToggle = document.getElementById('m-menu-mode-landscape')

        if(landscapeToggle == undefined || portraitToggle == undefined) return

        if(UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) this.setClickActionToButton(landscapeToggle, false)
        else this.setClickActionToButton(portraitToggle, true)
    }

    private setClickActionToButton(button: HTMLElement, shouldEnablePortrait: boolean) {
        button.classList.add('inactive')
        button.onclick = async() => {
            this.showNotification(shouldEnablePortrait)
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ClickedChangeMobileOrientation,
                category: AnalyticEventCategory.MobileAnalytics,
                stringValue: 'MENU',
                floatValue: shouldEnablePortrait ? UIMGameMode.PORTRAIT : UIMGameMode.LANDSCAPE,
            }
            await CA.sendAnalyticEvent(eventData)
            UIMMenuGameOrientationController.togglePortraitMode(shouldEnablePortrait)
        }
    }

    static togglePortraitMode(shouldEnablePortrait: boolean) {
        StorageWrapper.setPortraitGamePlayEnabled(shouldEnablePortrait)
        StorageWrapper.setTimestampUserSelectedGameMode(new Date().valueOf())
        setTimeout(() => {
            navigateToPage(getHomepageUrl())
        }, 100)
    }

    // eslint-disable-next-line class-methods-use-this
    private showNotification(isPortrait: boolean) {
        new UIMNotificationView({key: 'strings:roomPage.notifications.changedGameOrientation',
            options: {orientation: isPortrait ? 'portrait' : 'landscape'}},
        UITopNotificationType.Information)
    }
}
